import ReactApexChart from "react-apexcharts";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { H3, P } from "../../../AbstractElements";
import { SalesSummarys } from "../../../Constant";
import { SALES_SUMMARY_DATA } from "../../../Data/Dashboard";

const SalesSummary = () => {
  return (
    <Col xl="7" md="12" lg="6" className="box-col-6">
      <Card>
        <CardHeader className="card-no-border relative">
          <div className="header-top">
            <H3 className="m-0">{SalesSummarys}</H3>
          </div>
          <div className="d-flex sales-summary gap-2">
            <div className="d-flex align-items-center gap-1">
              <span></span>
              <P>Orders</P>
            </div>
            <div className="d-flex align-items-center gap-1">
              <span></span>
              <P>Orders</P>
            </div>
          </div>
        </CardHeader>
        <CardBody className="py-0">
          <div id="salessummary">
          <ReactApexChart options={SALES_SUMMARY_DATA} series={SALES_SUMMARY_DATA.series} type="bubble" height={400} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SalesSummary;
